import $ from 'jquery';

const $window = $(window);
const $body = $('.page');

const avatar = (element, index) => {
    const $logout = element.parent().find('.header__logout');
    const $menu = element.parent().children('.header__avatar-menu');

    $menu.off('click');
    element.off('click');
    $logout.off('click');
    $body.off('click.avatar' + index);
    $body.off('keydown.avatar' + index);
    $window.off('resize:width.avatar' + index);

    $menu.on('click', function (event) {
        event.stopPropagation();
    });
    element.on('click', function (event) {
        event.stopPropagation();
        toggleMenu($menu);
    });
    $logout.on('click', () => hideMenu($menu));
    $body.on('click.avatar' + index, () => hideMenu($menu));
    $body.on('keydown.avatar' + index, function (event) {
        if (event.key === 'Escape') {
            hideMenu($menu);
        }
    });
    $window.on('resize:width.avatar' + index, () => hideMenu($menu));
};

const toggleMenu = $menu => {
    $menu.hasClass('header__avatar-menu--active') ? hideMenu($menu) : showMenu($menu);
};
const showMenu = $menu => {
    $menu.addClass('header__avatar-menu--active');
};
const hideMenu = $menu => {
    $menu.removeClass('header__avatar-menu--active');
};

export const reloadScriptAvatar = () => {
    const $avatar = $('.header__avatar');

    $avatar.each(function (index) {
        avatar($(this), index);
    });
};
reloadScriptAvatar();
